export const initialMasterBpm: number = 120;
export const projectNameMaxLength: number = 20;
export const apiDomain =
  document.domain.indexOf('localhost') > -1
  ? 'https://localhost'
  : 'https://make.techwillsaveus.com';
